import { render, staticRenderFns } from "./StockClosingDetail_Total.vue?vue&type=template&id=744b1e8f&"
import script from "./StockClosingDetail_Total.vue?vue&type=script&lang=js&"
export * from "./StockClosingDetail_Total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports